import { useMutation, UseQueryResult } from '@tanstack/react-query'
import { queryClient, QueryOptions, UseMutationResult, useResource, useResources } from '.'
import {
  create,
  fetch,
  get,
  WorkPeriodEvent,
  WorkPeriodEventCreationPayload,
  WorkPeriodEventUpdatePayload,
  update,
} from '../api/work-period-events'

export const workPeriodEventKeys = {
  create: ['work-period-events', 'create'] as const,
  update: ['work-period-events', 'update'] as const,
} as const

//Queries
export const useWorkPeriodEventQuery = (id?: string): UseQueryResult<WorkPeriodEvent, any> =>
  useResource<WorkPeriodEvent>('work-period-events', get, id)

export const useWorkPeriodEventsQuery = (
  filters?: any,
  options?: QueryOptions<WorkPeriodEvent[]>,
): UseQueryResult<WorkPeriodEvent[], any> =>
  useResources<WorkPeriodEvent[], any>('work-period-events', fetch, filters, options)

//Mutations
const onMutationSuccess = () => {
  queryClient.invalidateQueries(['work-period-events'])
}

export const useCreateMutation = (): UseMutationResult<
  WorkPeriodEvent,
  WorkPeriodEventCreationPayload
> => useMutation(create, { mutationKey: workPeriodEventKeys.create, onSuccess: onMutationSuccess })

export const useUpdateMutation = (): UseMutationResult<
  WorkPeriodEvent,
  WorkPeriodEventUpdatePayload
> =>
  useMutation(update, {
    mutationKey: workPeriodEventKeys.update,
    onSuccess: onMutationSuccess,
  })
